import { COMPLETE_GET_NETWORKS } from '../actions/networkActions';

export default function networksReducer(state = {}, action) {
    switch (action.type) {
        case COMPLETE_GET_NETWORKS:
            return {
                ...state,
                data: action.networks,
                completeTime: action.completeTime
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./app/common/reducers/networksReducer.js